import { render, staticRenderFns } from "./TablePageMainHeader.vue?vue&type=template&id=139de7ce&scoped=true&"
import script from "./TablePageMainHeader.vue?vue&type=script&lang=js&"
export * from "./TablePageMainHeader.vue?vue&type=script&lang=js&"
import style0 from "./TablePageMainHeader.vue?vue&type=style&index=0&id=139de7ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "139de7ce",
  null
  
)

export default component.exports